export const SELECT_GROUP_MODAL_ROOT = 'select group modal root';
export const SELECT_GROUP_MODAL_GROUP_CARD = 'select group modal group card';
